import { render, staticRenderFns } from "./TranslateChatPopup.vue?vue&type=template&id=4184d7c2&"
import script from "./TranslateChatPopup.vue?vue&type=script&lang=js&"
export * from "./TranslateChatPopup.vue?vue&type=script&lang=js&"
import style0 from "./TranslateChatPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports